import { api } from "..";

import { Settings } from "@/types/Settings";

export interface UpdateSettingsParams {
  dealerMinBalance: number;
  refundCouponCredit: number;
  weeklyCancelQuota: number;
  // Optional: only the casino tab sends it; the sports form keeps its
  // three-field payload (the API accepts both).
  casinoDealerMinBalance?: number;
}

export const updateSettings = async (
  params: UpdateSettingsParams
): Promise<Settings> => {
  const res = await api.client.put("/settings", params);
  return res.data;
};
